var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-Close Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 28.208 18.208 20 10 11.792 11.792 10 20 18.208 28.208 10 30 11.792 21.792 20 30 28.208 28.208 30 20 21.792 11.792 30z"
}))));
export default SvgClose;